(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-sections"]) return;
  try {
    
  if (!document.querySelector && !window.addEventListener && !("classList" in d.createElement("p"))) return;
  var Tabs = function () {
    this.ele = document.querySelector('[data-tabs]');
    if (!this.ele) return;

    this.actions = this.ele.querySelectorAll('[data-tab-target]');
    this.active = this.ele.querySelector('[data-tab-active]');
    if (this.actions.length) {
      document.documentElement.classList.add('has-tabs');
      this._addEventListeners();
      this.closeAllTabs();
      this.openActive();
    }
  };
  Tabs.prototype.openTab = function (ele) {
    this.active = ele;
    ele.setAttribute('data-tab-active', '');
    var targetStr = ele.getAttribute('data-tab-target');
    var target = this.ele.querySelector(targetStr);
    target.style.display = 'block';
  };
  Tabs.prototype.closeTab = function (ele) {
    ele.removeAttribute('data-tab-active');
    var targetStr = ele.getAttribute('data-tab-target');
    var target = this.ele.querySelector(targetStr);
    target.style.display = 'none';
  };
  Tabs.prototype.closeAllTabs = function () {
    var target,
      targetStr,
      _this = this;
    this._eachAction(function (tabAction) {
      _this.closeTab(tabAction);
    });
  };
  Tabs.prototype.openActive = function () {
    var active = this.active;
    if (!!location.hash) {
      active = this.ele.querySelector('[href="'+location.hash+'"]');
    }
    if (active) {
      this.openTab(active);
    }
  };
  Tabs.prototype._updateHash = function (hash) {
    if (history.pushState) {
      history.pushState(null, null, hash);
    } else {
      location.hash = hash;
    }
  };
  Tabs.prototype._addEventListeners = function () {
    var _this = this;
    this._eachAction(function (tabAction) {
      tabAction.addEventListener('click', function (e) {
        e.preventDefault();
        _this.closeAllTabs();
        _this.openTab(e.currentTarget);
        _this._updateHash(e.currentTarget.getAttribute('href'));
        e.currentTarget.blur();
      });
    });
  };
  Tabs.prototype._eachAction = function (callback) {
    for (var i = 0; i < this.actions.length; i++) {
      callback(this.actions[i]);
    }
  };
  new Tabs();

  $(document).on('shopify:section:load', function () {
    new Tabs();
  });

  // Youtube video
  $('.slideshow__video').each(function() {
    var $el = $(this);
    theme.SlideshowVideo.init($el);
    theme.SlideshowVideo.loadVideo($el.attr('id'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // filter slides based on growthbook experiment
  if (window._growthbook && templateJSON === 'index') {
    const hpHeroTest = window._growthbook.getFeatureValue("homepage-hero-content-testing", 0);
    const hpHeroTestIndex = parseInt(hpHeroTest);
    const slides = document.querySelectorAll('[data-hp-slides]');
    const slideLength = slides.length;

    slides.forEach((slide) => {
      const experimentIndex = parseInt(slide.dataset.experimentVariation);
      if (experimentIndex === hpHeroTestIndex) return;
      slide.remove();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
